import { HasShellContext } from "@insite/client-framework/Components/IsInShell";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { useEffect } from "react";

const enum fields {
    source = "source",
    apiKey = "apiKey",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.source]: string;
        [fields.apiKey]: string;
    };
}

type Props = OwnProps & HasShellContext;

const WeglotScript: React.FunctionComponent<Props> = props => {
    const source = props.fields.source;
    const apiKey = props.fields.apiKey;

    useEffect(() => {
        const scriptCall = document.createElement("script");
        scriptCall.innerHTML = "";
        scriptCall.type = "text/javascript";
        scriptCall.src = source;
        document.head.appendChild(scriptCall);
        scriptCall.onload = () => {
            const scriptCall2 = document.createElement("script");
            scriptCall2.innerHTML = `Weglot.initialize({api_key: '${apiKey}'});`;
            document.head.appendChild(scriptCall2);
        };
    }, []);

    return (<></>);
};

const widgetModule: WidgetModule = {
    component: WeglotScript,
    definition: {
        group: "Basic",
        icon: "FormField",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.source,
                editorTemplate: "TextField",
                displayName: "Weglot JS Source",
                defaultValue: "https://cdn.weglot.com/weglot.min.js",
            },
            {
                fieldType: "General",
                name: fields.apiKey,
                editorTemplate: "TextField",
                displayName: "Api Key",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;